import { i18n } from '@/main.js'

export default {
    getPartners: (state) => {
        return state.partners;
    },
    getLoadingPartners: (state) => {
        return state.loadingPartners;
    }
}